<template>
  <div>
    <div class="jumbotron">
      <h1>Mon compte</h1>
      <h4>Gérez ici les paramètres de votre compte</h4>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <h2>Modifier vos informations</h2>

          <div
            class="alert alert-danger"
            role="alert"
            v-bind:class="{ hide: status.updateinfo.errorMessage == null }"
          >{{status.updateinfo.errorMessage}}</div>

          <form @submit.prevent="updateInfo">
            <div class="control-group">
              <div class="form-group floating-label-form-group controls mb-0 pb-2">
                <label>Prénom</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="updateInfoForm.firstname"
                  placeholder="Prénom"
                />
              </div>
            </div>

            <div class="control-group">
              <div class="form-group floating-label-form-group controls mb-0 pb-2">
                <label>Nom de famille</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="updateInfoForm.lastname"
                  placeholder="Nom de famille"
                />
              </div>
            </div>

            <div class="control-group control-group-switch">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch1"
                  v-model="updateInfoForm.newsletterActivated"
                />
                <label class="custom-control-label" for="customSwitch1">Recevoir la newsletter</label>
              </div>
            </div>

            <div class="control-group control-group-switch">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch2"
                  v-model="updateInfoForm.notificationActivated"
                />
                <label
                  class="custom-control-label"
                  for="customSwitch2"
                >Recevoir les notifications liées aux recherches</label>
              </div>
            </div>

            <br />
            <div class="form-group">
              <button
                type="submit"
                class="btn btn-primary btn-xl"
                v-bind:class="{ hide: status.updateinfo.loading == true }"
              >Mettre à jour vos infos</button>

              <div
                class="spinner-border text-primary"
                role="status"
                v-bind:class="{ hide: status.updateinfo.loading == false }"
              >
                <span class="sr-only">Mise à jour en cours...</span>
              </div>
            </div>
          </form>
        </div>

        <div class="col-md-6">
          <h2>Modifier votre mot de passe</h2>

          <div
            class="alert alert-danger"
            role="alert"
            v-bind:class="{ hide: status.updatepassword.errorMessage == null }"
          >{{status.updatepassword.errorMessage}}</div>

          <form @submit.prevent="updatePassword">
            <div class="control-group">
              <div class="form-group floating-label-form-group controls mb-0 pb-2">
                <label>Ancien mot de passe</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="updatePasswordForm.oldpassword"
                  placeholder="Ancien mot de passe"
                />
              </div>
            </div>

            <div class="control-group">
              <div class="form-group floating-label-form-group controls mb-0 pb-2">
                <label>Nouveau mot de passe</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="updatePasswordForm.newpassword"
                  placeholder="Nouveau mot de passe"
                />
              </div>
            </div>

            <br />
            <div class="form-group">
              <button
                type="submit"
                class="btn btn-primary btn-xl"
                v-bind:class="{ hide: status.updatepassword.loading == true }"
              >Changer le mot de passe</button>

              <div
                class="spinner-border text-primary"
                role="status"
                v-bind:class="{ hide: status.updatepassword.loading == false }"
              >
                <span class="sr-only">Mot de passe en cours de modification...</span>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <a class="btn btn-info btn-outline" href="javascript:showAxeptioButton()">
            Cliquez-ici pour modifier vos préférences en matière de cookies
          </a>
          <button class="btn btn-danger btn-outline" @click="logoff">Se déconnecter</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "UserAccount",
  getterMethods: null,
  data() {
    return {
      updatePasswordForm: {
        oldpassword: "",
        newpassword: ""
      },
      updateInfoForm: {
        firstname: "",
        lastname: "",
        newsletterActivated: false,
        notificationActivated: false
      },
      errorLogin: {},
      status: {
        updatepassword: { loading: false, errorMessage: null },
        updateinfo: { loading: false, errorMessage: null }
      }
    };
  },
  mounted() {
    var vm = this;
    vm.status.updateinfo.loading = true;
    axios.get(process.env.BACKEND_URL + "/api/users").then(response => {
      vm.updateInfoForm = response.data;
      vm.status.updateinfo.loading = false;
    });
  },
  methods: {
    updateInfo: function() {
      var vm = this;
      vm.status.updateinfo.loading = true;
      vm.status.updateinfo.errorMessage = null;

      axios
        .put(process.env.BACKEND_URL + "/api/users", vm.updateInfoForm)
        .then(response => {
          console.log(response);

          if (response.status != 200) {
            vm.status.updateinfo.errorMessage = "Erreur non prise en charge";
          }

          vm.status.updateinfo.loading = false;
        })
        .catch(error => {
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 409)
              vm.status.updateinfo.errorMessage = "Utilisateur déjà existant";
            else if (error.response.status == 500)
              vm.status.updateinfo.errorMessage =
                "Erreur serveur : <br /><i>" +
                JSON.stringify(error.response.data) +
                "</i>";
          } else
            vm.status.updateinfo.errorMessage =
              "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.updateinfo.loading = false;
        });

      return false;
    },
    updatePassword: function() {
      var vm = this;
      vm.status.updatepassword.loading = true;
      vm.status.updatepassword.errorMessage = null;

      axios
        .put(process.env.BACKEND_URL + "/api/users/password", vm.updatePasswordForm)
        .then(response => {
          console.log(response);

          if (response.status != 200) {
            vm.status.updatepassword.errorMessage = "Erreur non prise en charge";
          }

          vm.status.updatepassword.loading = false;
        })
        .catch(error => {
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 400)
              vm.status.updatepassword.errorMessage = "Mauvais mot de passe";
            else if (error.response.status == 500)
              vm.status.updatepassword.errorMessage =
                "Erreur serveur : <br /><i>" +
                JSON.stringify(error.response.data) +
                "</i>";
          } else
            vm.status.updatepassword.errorMessage =
              "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.updatepassword.loading = false;
        });

      return false;
    },
    logoff: function() {
      this.$store.dispatch("logOut").then(() => {
        this.$router.push("/");
      });
    }
  }
};
</script>

<style scope>
.control-group-switch {
  text-align: left;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/users/UserAccount.vue